import approvalChainTemplates from "./organisation-approval-chain-templates";

export const APPROVAL_CHAIN_TEMPLATE_NAMESPACE = `organisations/approvalChainTemplates`;

export default approvalChainTemplates;
